import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const OUTCOMES = ['Menos hinchazón al final del día', 'Más claridad mental y energía estable', 'Menos ansiedad nocturna y mejor descanso', 'Menos antojos durante la tarde', 'Sentirte más cómoda con tu ropa', 'Más confianza en tu cuerpo'];
function OutcomeItem({
  item,
  index
}: {
  item: string;
  index: number;
}) {
  return <motion.li initial={{
    opacity: 0,
    y: 12
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.08
  }} className="flex items-start gap-3 rounded-[3px] border-[0.5px] border-gold/15 bg-white/[0.02] px-4 py-3" data-id="element-37">
      <span className="w-2 h-2 rounded-full bg-[#C8A870] mt-2 flex-shrink-0" data-id="element-38" />

      <span className="font-body text-foreground/80 text-[16px] leading-[1.5]" data-id="element-39">
        {item}
      </span>
    </motion.li>;
}
export function DifferenceSection() {
  const [expanded, setExpanded] = useState(false);
  const visible = OUTCOMES.slice(0, 3);
  const hidden = OUTCOMES.slice(3);
  return <section className="bg-gradient-hero py-24 md:py-32 px-5 md:px-8" data-id="element-40">
      <div className="max-w-xl mx-auto" data-id="element-41">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="font-display font-semibold text-[#F0E8D8] text-center leading-[1.12]" data-id="element-42">
          <span className="block text-[32px] md:text-5xl" data-id="element-43">
            Cambios que podés empezar
          </span>

          <span className="block text-[32px] md:text-5xl mt-1" data-id="element-44">
            a{' '}
            <span className="italic text-gradient-gold" data-id="element-45">notar en 21 días</span>
          </span>
        </motion.h2>

        <ul className="mt-10 grid gap-3 md:grid-cols-2" data-id="element-46">
          {visible.map((item, i) => <OutcomeItem key={i} item={item} index={i} data-id="element-47" />)}
        </ul>

        {/* Resto de los cambios — revelado con animación premium */}
        <AnimatePresence initial={false} data-id="element-48">
          {expanded && <motion.ul key="hidden-outcomes" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.28,
          ease: 'easeOut'
        }} className="overflow-hidden grid gap-3 md:grid-cols-2 mt-3" data-id="element-49">
              {hidden.map((item, i) => <OutcomeItem key={i} item={item} index={i} data-id="element-50" />)}
            </motion.ul>}
        </AnimatePresence>

        <div className="mt-8 flex justify-center" data-id="element-51">
          <button type="button" onClick={() => setExpanded(v => !v)} aria-expanded={expanded} className="group inline-flex items-center gap-2 font-body uppercase tracking-[0.18em] text-[13px] text-[#C8A870] hover:text-[#E8D5B0] transition-colors duration-300 focus:outline-none" data-id="element-52">
            {expanded ? 'Ver menos cambios' : 'Ver todos los cambios'}
            <motion.span animate={{
            rotate: expanded ? 180 : 0
          }} transition={{
            duration: 0.28,
            ease: 'easeOut'
          }} className="inline-flex" data-id="element-53">
              <ChevronDownIcon className="w-4 h-4" data-id="element-54" />
            </motion.span>
          </button>
        </div>
      </div>
    </section>;
}